var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlyplayLogoBirthday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 101,
    viewBox: "0 0 180 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2281 33.2205C68.2281 27.16 63.6463 22.909 57.8831 22.909C52.1487 22.909 47.4805 27.16 47.4805 33.2205C47.4805 39.281 52.1487 43.5607 57.8831 43.5607C63.6175 43.5607 68.2281 39.281 68.2281 33.2205ZM52.5233 33.2205C52.5233 29.6301 54.598 27.361 57.8831 27.361C61.1105 27.361 63.2141 29.6301 63.2141 33.2205C63.2141 36.7534 61.1105 39.0799 57.8831 39.0799C54.598 39.0799 52.5233 36.7534 52.5233 33.2205Z",
    fill: "url(#paint0_linear_1065_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7754 43.3597H86.6742V33.996C86.6742 29.6876 84.196 27.16 80.4787 27.16C78.3175 27.16 76.5886 28.1078 75.6088 29.4578V27.3323H70.6813V43.3597H75.6088V34.6566C75.6088 32.4737 76.8191 31.2673 78.6921 31.2673C80.5652 31.2673 81.7754 32.4737 81.7754 34.6566V43.3597Z",
    fill: "url(#paint1_linear_1065_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8102 43.3597H94.7377V22.1047H89.8102V43.3597Z",
    fill: "url(#paint2_linear_1065_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.426 37.3566L101.709 27.3323H96.2051L102.746 42.8139L99.0579 50.9712H104.36L114.446 27.3323H109.115L105.426 37.3566Z",
    fill: "url(#paint3_linear_1065_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.867 29.6014V27.3323H115.939V50.9999H120.867V41.1193C121.76 42.4692 123.46 43.5894 125.823 43.5894C129.771 43.5894 132.912 40.3725 132.912 35.3173C132.912 30.262 129.771 27.1025 125.823 27.1025C123.46 27.1025 121.76 28.194 120.867 29.6014ZM127.898 35.3173C127.898 37.8736 126.227 39.3097 124.354 39.3097C122.509 39.3097 120.838 37.9023 120.838 35.346C120.838 32.7896 122.509 31.3822 124.354 31.3822C126.227 31.3822 127.898 32.7609 127.898 35.3173Z",
    fill: "url(#paint4_linear_1065_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.209 43.3597H140.137V22.1047H135.209V43.3597Z",
    fill: "url(#paint5_linear_1065_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.44 35.3173C142.44 40.3725 145.581 43.5894 149.5 43.5894C151.891 43.5894 153.591 42.498 154.485 41.0905V43.3597H159.412V27.3323H154.485V29.6014C153.62 28.194 151.92 27.1025 149.528 27.1025C145.581 27.1025 142.44 30.262 142.44 35.3173ZM154.485 35.346C154.485 37.9023 152.842 39.3097 150.969 39.3097C149.125 39.3097 147.454 37.8736 147.454 35.3173C147.454 32.7609 149.125 31.3822 150.969 31.3822C152.842 31.3822 154.485 32.7896 154.485 35.346Z",
    fill: "url(#paint6_linear_1065_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.095 37.3566L166.377 27.3323H160.874L167.415 42.8139L163.726 50.9712H169.029L179.114 27.3323H173.783L170.095 37.3566Z",
    fill: "url(#paint7_linear_1065_2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.053,
    cy: 33.0528,
    r: 13.043,
    stroke: "url(#paint8_linear_1065_2)",
    strokeWidth: 4.01322
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0529,
    cy: 33.0529,
    r: 5.01653,
    fill: "url(#paint9_linear_1065_2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1065_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179 58H47.9184H42.097H8L16.479 76.1061L8 92.4947H36.4473H47.9184H179L170.512 76.1061L179 58Z",
    fill: "url(#paint10_linear_1065_2)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1065_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.944 71.704H32.952V73.912C33.1653 73.6773 33.464 73.4853 33.848 73.336C34.232 73.1867 34.648 73.112 35.096 73.112C35.896 73.112 36.5573 73.2933 37.08 73.656C37.6133 74.0187 38.0027 74.488 38.248 75.064C38.4933 75.64 38.616 76.264 38.616 76.936C38.616 78.184 38.264 79.176 37.56 79.912C36.856 80.6373 35.864 81 34.584 81C33.7307 81 32.9893 80.856 32.36 80.568C31.7307 80.2693 31.2453 79.8587 30.904 79.336C30.5627 78.8133 30.376 78.2107 30.344 77.528H33.016C33.08 77.8587 33.2347 78.136 33.48 78.36C33.7253 78.5733 34.0613 78.68 34.488 78.68C34.9893 78.68 35.3627 78.52 35.608 78.2C35.8533 77.88 35.976 77.4533 35.976 76.92C35.976 76.3973 35.848 75.9973 35.592 75.72C35.336 75.4427 34.9627 75.304 34.472 75.304C34.1093 75.304 33.8107 75.3947 33.576 75.576C33.3413 75.7467 33.1867 75.976 33.112 76.264H30.472V69.304H37.944V71.704ZM52.2689 72.072L46.6689 85.24H43.7249L45.7729 80.696L42.1409 72.072H45.1969L47.2609 77.656L49.3089 72.072H52.2689ZM61.3543 76.392C61.3543 76.648 61.3383 76.9147 61.3063 77.192H55.1143C55.1569 77.7467 55.3329 78.1733 55.6423 78.472C55.9623 78.76 56.3516 78.904 56.8103 78.904C57.4929 78.904 57.9676 78.616 58.2343 78.04H61.1463C60.9969 78.6267 60.7249 79.1547 60.3303 79.624C59.9463 80.0933 59.4609 80.4613 58.8743 80.728C58.2876 80.9947 57.6316 81.128 56.9063 81.128C56.0316 81.128 55.2529 80.9413 54.5703 80.568C53.8876 80.1947 53.3543 79.6613 52.9703 78.968C52.5863 78.2747 52.3943 77.464 52.3943 76.536C52.3943 75.608 52.5809 74.7973 52.9543 74.104C53.3383 73.4107 53.8716 72.8773 54.5543 72.504C55.2369 72.1307 56.0209 71.944 56.9063 71.944C57.7703 71.944 58.5383 72.1253 59.2103 72.488C59.8823 72.8507 60.4049 73.368 60.7783 74.04C61.1623 74.712 61.3543 75.496 61.3543 76.392ZM58.5543 75.672C58.5543 75.2027 58.3943 74.8293 58.0743 74.552C57.7543 74.2747 57.3543 74.136 56.8743 74.136C56.4156 74.136 56.0263 74.2693 55.7063 74.536C55.3969 74.8027 55.2049 75.1813 55.1303 75.672H58.5543ZM61.9336 76.52C61.9336 75.6027 62.1043 74.7973 62.4456 74.104C62.7976 73.4107 63.2723 72.8773 63.8696 72.504C64.467 72.1307 65.1336 71.944 65.8696 71.944C66.499 71.944 67.0483 72.072 67.5176 72.328C67.9976 72.584 68.3656 72.92 68.6216 73.336V72.072H71.3576V81H68.6216V79.736C68.355 80.152 67.9816 80.488 67.5016 80.744C67.0323 81 66.483 81.128 65.8536 81.128C65.1283 81.128 64.467 80.9413 63.8696 80.568C63.2723 80.184 62.7976 79.6453 62.4456 78.952C62.1043 78.248 61.9336 77.4373 61.9336 76.52ZM68.6216 76.536C68.6216 75.8533 68.4296 75.3147 68.0456 74.92C67.6723 74.5253 67.2136 74.328 66.6696 74.328C66.1256 74.328 65.6616 74.5253 65.2776 74.92C64.9043 75.304 64.7176 75.8373 64.7176 76.52C64.7176 77.2027 64.9043 77.7467 65.2776 78.152C65.6616 78.5467 66.1256 78.744 66.6696 78.744C67.2136 78.744 67.6723 78.5467 68.0456 78.152C68.4296 77.7573 68.6216 77.2187 68.6216 76.536ZM75.753 73.56C76.073 73.0693 76.473 72.6853 76.953 72.408C77.433 72.12 77.9663 71.976 78.553 71.976V74.872H77.801C77.1183 74.872 76.6063 75.0213 76.265 75.32C75.9237 75.608 75.753 76.12 75.753 76.856V81H73.017V72.072H75.753V73.56ZM83.1728 81.128C82.3941 81.128 81.7008 80.9947 81.0928 80.728C80.4848 80.4613 80.0048 80.0987 79.6528 79.64C79.3008 79.1707 79.1034 78.648 79.0608 78.072H81.7648C81.7968 78.3813 81.9408 78.632 82.1968 78.824C82.4528 79.016 82.7674 79.112 83.1408 79.112C83.4821 79.112 83.7434 79.048 83.9248 78.92C84.1168 78.7813 84.2128 78.6053 84.2128 78.392C84.2128 78.136 84.0794 77.9493 83.8128 77.832C83.5461 77.704 83.1141 77.5653 82.5168 77.416C81.8768 77.2667 81.3434 77.112 80.9168 76.952C80.4901 76.7813 80.1221 76.52 79.8128 76.168C79.5034 75.8053 79.3488 75.32 79.3488 74.712C79.3488 74.2 79.4874 73.736 79.7648 73.32C80.0528 72.8933 80.4688 72.5573 81.0128 72.312C81.5674 72.0667 82.2234 71.944 82.9808 71.944C84.1008 71.944 84.9808 72.2213 85.6208 72.776C86.2714 73.3307 86.6448 74.0667 86.7408 74.984H84.2128C84.1701 74.6747 84.0314 74.4293 83.7968 74.248C83.5728 74.0667 83.2741 73.976 82.9008 73.976C82.5808 73.976 82.3354 74.04 82.1648 74.168C81.9941 74.2853 81.9088 74.4507 81.9088 74.664C81.9088 74.92 82.0421 75.112 82.3088 75.24C82.5861 75.368 83.0128 75.496 83.5888 75.624C84.2501 75.7947 84.7888 75.9653 85.2048 76.136C85.6208 76.296 85.9834 76.5627 86.2928 76.936C86.6128 77.2987 86.7781 77.7893 86.7888 78.408C86.7888 78.9307 86.6394 79.4 86.3408 79.816C86.0528 80.2213 85.6314 80.5413 85.0768 80.776C84.5328 81.0107 83.8981 81.128 83.1728 81.128ZM104.029 72.072L101.613 81H98.5892L97.1812 75.208L95.7252 81H92.7172L90.2852 72.072H93.0212L94.2852 78.456L95.7892 72.072H98.6852L100.205 78.424L101.453 72.072H104.029ZM106.129 71.144C105.649 71.144 105.254 71.0053 104.945 70.728C104.646 70.44 104.497 70.088 104.497 69.672C104.497 69.2453 104.646 68.8933 104.945 68.616C105.254 68.328 105.649 68.184 106.129 68.184C106.598 68.184 106.982 68.328 107.281 68.616C107.59 68.8933 107.745 69.2453 107.745 69.672C107.745 70.088 107.59 70.44 107.281 70.728C106.982 71.0053 106.598 71.144 106.129 71.144ZM107.489 72.072V81H104.753V72.072H107.489ZM114.127 78.68V81H112.735C111.743 81 110.97 80.76 110.415 80.28C109.861 79.7893 109.583 78.9947 109.583 77.896V74.344H108.495V72.072H109.583V69.896H112.319V72.072H114.111V74.344H112.319V77.928C112.319 78.1947 112.383 78.3867 112.511 78.504C112.639 78.6213 112.853 78.68 113.151 78.68H114.127ZM120.819 71.976C121.843 71.976 122.665 72.3173 123.283 73C123.902 73.672 124.211 74.6 124.211 75.784V81H121.491V76.152C121.491 75.5547 121.337 75.0907 121.027 74.76C120.718 74.4293 120.302 74.264 119.779 74.264C119.257 74.264 118.841 74.4293 118.531 74.76C118.222 75.0907 118.067 75.5547 118.067 76.152V81H115.331V69.16H118.067V73.272C118.345 72.8773 118.723 72.5627 119.203 72.328C119.683 72.0933 120.222 71.976 120.819 71.976ZM137.983 72.072L132.383 85.24H129.439L131.487 80.696L127.855 72.072H130.911L132.975 77.656L135.023 72.072H137.983ZM142.717 81.128C141.842 81.128 141.053 80.9413 140.349 80.568C139.655 80.1947 139.106 79.6613 138.701 78.968C138.306 78.2747 138.109 77.464 138.109 76.536C138.109 75.6187 138.311 74.8133 138.717 74.12C139.122 73.416 139.677 72.8773 140.381 72.504C141.085 72.1307 141.874 71.944 142.749 71.944C143.623 71.944 144.413 72.1307 145.117 72.504C145.821 72.8773 146.375 73.416 146.781 74.12C147.186 74.8133 147.389 75.6187 147.389 76.536C147.389 77.4533 147.181 78.264 146.765 78.968C146.359 79.6613 145.799 80.1947 145.085 80.568C144.381 80.9413 143.591 81.128 142.717 81.128ZM142.717 78.76C143.239 78.76 143.682 78.568 144.045 78.184C144.418 77.8 144.605 77.2507 144.605 76.536C144.605 75.8213 144.423 75.272 144.061 74.888C143.709 74.504 143.271 74.312 142.749 74.312C142.215 74.312 141.773 74.504 141.421 74.888C141.069 75.2613 140.893 75.8107 140.893 76.536C140.893 77.2507 141.063 77.8 141.405 78.184C141.757 78.568 142.194 78.76 142.717 78.76ZM157.336 72.072V81H154.6V79.784C154.323 80.1787 153.944 80.4987 153.464 80.744C152.995 80.9787 152.472 81.096 151.896 81.096C151.213 81.096 150.611 80.9467 150.088 80.648C149.565 80.3387 149.16 79.896 148.872 79.32C148.584 78.744 148.44 78.0667 148.44 77.288V72.072H151.16V76.92C151.16 77.5173 151.315 77.9813 151.624 78.312C151.933 78.6427 152.349 78.808 152.872 78.808C153.405 78.808 153.827 78.6427 154.136 78.312C154.445 77.9813 154.6 77.5173 154.6 76.92V72.072H157.336Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.042 93.387C19.8115 93.4494 20.4147 94.1426 20.6296 94.8844C20.8445 95.6262 20.7752 96.4235 20.7405 97.193C20.7059 97.9695 20.7267 98.7806 21.101 99.4601C21.4754 100.139 22.3142 100.618 23.0422 100.347",
    stroke: "white",
    strokeWidth: 0.741804,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6101 62.9383C12.8924 61.7389 9.95294 61.732 7.36702 62.6748V62.661C7.31156 62.6817 7.26303 62.7025 7.2145 62.7233C7.16597 62.7441 7.11051 62.758 7.06198 62.7719V62.7857C4.51766 63.8326 2.35465 65.8154 1.14835 68.533C-1.8258 75.3895 1.43952 82.4817 5.6685 86.1214C10.3966 90.1978 16.7401 91.5289 18.3069 91.7993L18.3762 91.9726C18.3762 91.9726 18.4248 91.9171 18.4941 91.827C18.5981 91.8478 18.6743 91.8547 18.6743 91.8547L18.605 91.6814C19.5756 90.4266 23.3678 85.1716 24.1165 78.9737C24.789 73.4344 22.4249 65.9887 15.6101 62.9313V62.9383Z",
    fill: "url(#paint11_linear_1065_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0225 70.8347C10.8891 72.9631 11.9775 75.1122 13.3641 76.9771C15.1319 79.3551 17.3989 79.7641 19.8323 78.0101C19.8392 78.0101 19.8531 77.9963 19.86 77.9893C21.3436 76.9078 21.9537 74.9736 21.4754 73.1988C20.5602 69.8087 18.3903 66.5642 14.6466 64.8795C12.5391 63.9505 10.1819 63.8743 7.99811 64.6715L7.90105 64.7062L7.78319 64.7547C7.74853 64.7686 7.71386 64.7894 7.6792 64.8032C8.39327 66.9871 9.21134 68.8242 10.0294 70.8347H10.0225Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.945 76.8105C20.7681 86.6827 12.0329 88.097 5.33585 83.459C3.36002 82.0932 1.68923 80.367 0.621582 78.2178C1.56444 81.4346 3.48481 84.2424 5.66862 86.1212C10.3968 90.1976 16.7402 91.5287 18.307 91.7991L18.3763 91.9724C18.3763 91.9724 18.4249 91.917 18.4942 91.8268C18.5982 91.8476 18.6745 91.8546 18.6745 91.8546L18.6051 91.6812C19.5757 90.4264 23.3679 85.1714 24.1167 78.9735C24.394 76.6926 24.1444 74.0929 23.2917 71.604C23.4581 73.3441 23.3263 75.0842 22.945 76.7966V76.8105Z",
    fill: "#C4007A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7421 66.2731C16.269 65.9334 16.2482 65.1292 15.6797 64.8519C15.6797 64.8519 15.6727 64.8519 15.6658 64.8519C13.1492 63.5832 10.0919 63.292 7.64462 64.422C7.54062 64.4706 7.45743 64.5676 7.43663 64.6855C7.39504 64.8865 7.52676 65.0876 7.72781 65.1292H7.73474C9.23221 65.4411 10.5494 65.9472 11.7211 66.5989C12.8719 67.2367 14.2654 67.2021 15.3816 66.5019C15.4994 66.4256 15.6173 66.3493 15.7421 66.2731Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3055 67.6249C19.5828 68.3321 19.1044 69.1779 18.2448 69.5176C17.3851 69.8573 16.4631 69.5453 16.1857 68.8382C15.9084 68.131 16.3868 67.2852 17.2465 66.9455C18.1061 66.6128 19.0282 66.9178 19.3055 67.6249Z",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3399 92.5621C19.1389 92.3888 18.9378 92.2224 18.7437 92.0491C18.9309 91.9381 19.0488 91.7787 19.0002 91.6539C18.9448 91.5083 18.6883 91.4667 18.4317 91.5638C18.1752 91.6608 18.0088 91.8619 18.0712 92.0144C18.1128 92.1323 18.2792 92.1739 18.4733 92.1461C18.4456 92.3541 18.4179 92.576 18.3694 92.8117C18.3208 93.0474 18.2654 93.2623 18.203 93.4634C18.1475 93.7545 18.4317 93.9902 18.7091 93.8793L19.742 93.4772C19.8114 93.4356 19.95 93.3316 19.9777 93.1791C20.0124 92.9434 19.7767 92.6453 19.3538 92.5552L19.3399 92.5621Z",
    fill: "#C4007A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.907 29.1274C157.155 29.1884 156.566 29.8654 156.356 30.5899C156.146 31.3143 156.214 32.0929 156.248 32.8444C156.282 33.6027 156.261 34.3948 155.896 35.0584C155.53 35.7219 154.711 36.189 154 35.925",
    stroke: "white",
    strokeWidth: 0.724438,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.556 7.92242C177.798 5.11946 176.004 2.88521 173.695 1.49727V1.48373C173.655 1.45665 173.607 1.43634 173.567 1.40926C173.519 1.38217 173.479 1.35509 173.438 1.32801V1.34155C171.075 0.0483967 168.238 -0.384912 165.435 0.373378C158.401 2.32327 155.016 9.15464 154.846 14.6048C154.657 20.6982 157.534 26.3313 158.286 27.6921L158.198 27.8478C158.198 27.8478 158.272 27.8478 158.374 27.8478C158.428 27.9426 158.462 28.0036 158.462 28.0036L158.55 27.8478C160.1 27.814 166.417 27.4687 171.59 24.2324C176.207 21.3482 180.412 14.984 178.556 7.92242Z",
    fill: "url(#paint12_linear_1065_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.132 8.53185C168.049 10.4953 167.081 12.6415 166.519 14.8419C165.801 17.6449 166.877 19.6151 169.701 20.3869C169.714 20.3869 169.721 20.3869 169.735 20.3937C171.468 20.8608 173.309 20.1296 174.366 18.674C176.376 15.8981 177.514 12.2556 176.498 8.38289C175.909 6.20958 174.521 4.37479 172.578 3.20351L172.497 3.14934L172.389 3.08841C172.389 3.08841 172.321 3.05456 172.287 3.04102C171.068 4.9232 170.168 6.66997 169.146 8.52507L169.132 8.53185Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.524 22.0116C163.689 26.4191 157.257 20.6507 156.668 12.7157C156.492 10.3732 156.776 8.0509 157.758 5.91821C155.889 8.60608 154.934 11.7882 154.846 14.6047C154.657 20.6981 157.534 26.3311 158.286 27.692L158.198 27.8477C158.198 27.8477 158.272 27.8477 158.374 27.8477C158.428 27.9425 158.462 28.0034 158.462 28.0034L158.55 27.8477C160.1 27.8138 166.417 27.4685 171.59 24.2323C173.492 23.0407 175.313 21.26 176.681 19.0867C175.462 20.2851 174.061 21.2465 172.524 22.0116Z",
    fill: "#26B1C4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.106 10.0687C176.688 10.2582 177.284 9.75045 177.148 9.14788C177.148 9.14788 177.148 9.14111 177.148 9.13434C176.566 6.44648 174.907 3.94141 172.551 2.7769C172.45 2.7295 172.328 2.72273 172.226 2.7769C172.05 2.87168 171.976 3.08834 172.07 3.26437C172.754 4.60491 173.181 5.91161 173.404 7.20477C173.621 8.47084 174.508 9.50672 175.727 9.93325C175.855 9.98065 175.984 10.0213 176.119 10.0687H176.106Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.264 13.6096C176.891 14.2528 175.957 14.4085 175.172 13.9616C174.386 13.5148 174.054 12.6211 174.427 11.9779C174.799 11.3347 175.734 11.179 176.519 11.6258C177.304 12.0727 177.636 12.9664 177.264 13.6096Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.34 28.9378C158.347 28.6805 158.353 28.4232 158.36 28.166C158.557 28.2472 158.753 28.2337 158.814 28.1186C158.888 27.9832 158.766 27.7665 158.529 27.6311C158.293 27.4957 158.042 27.4957 157.968 27.6311C157.907 27.7327 157.968 27.8884 158.11 28.017C157.934 28.1253 157.751 28.2404 157.541 28.342C157.331 28.4503 157.135 28.5383 156.945 28.6128C156.695 28.7482 156.688 29.1071 156.938 29.2492L157.873 29.7909C157.947 29.818 158.11 29.8653 158.245 29.7909C158.448 29.6758 158.529 29.3102 158.34 28.931V28.9378Z",
    fill: "#26B1C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1065_2",
    x: 26.344,
    y: 68.1841,
    width: 134.992,
    height: 25.0559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.223529 0 0 0 0 0.223529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1065_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1065_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1065_2",
    x1: 113.297,
    y1: 22.1047,
    x2: 113.297,
    y2: 59.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1065_2",
    x1: 24.053,
    y1: 18.0032,
    x2: 24.053,
    y2: 56.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1065_2",
    x1: 24.0529,
    y1: 28.0364,
    x2: 24.0529,
    y2: 41.0208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1065_2",
    x1: 93.4955,
    y1: 58.6237,
    x2: 93.4955,
    y2: 102.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1065_2",
    x1: 8.8229,
    y1: 66.6126,
    x2: 16.338,
    y2: 86.6413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD006C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1065_2",
    x1: 171.393,
    y1: 4.06327,
    x2: 160.493,
    y2: 25.8641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26B1C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#219AAB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1065_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 34.4947,
    fill: "white",
    transform: "translate(8 58)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyplayLogoBirthday);
export default __webpack_public_path__ + "static/media/onlyplay_logo_birthday.ca388b973879ff3024322591d44036a9.svg";
export { ForwardRef as ReactComponent };